import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {removeFromPrintQueue, clearPrintQueue} from '../actions';
import {browserHistory} from 'react-router';
import PrintQueueCard from '../components/PrintQueueCard';
import {DragDropContext} from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import _ from "lodash";
import {Button} from 'react-bootstrap';
import {printRoute} from '../../../constants/public-routes';
import {FormattedMessage} from 'react-intl';

class PrintQueueContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      printShowed: false,
      selections: [],
      returning: false
    };

    this.fetchIfNeeded = this.fetchIfNeeded.bind(this);
    this.moveCard = this.moveCard.bind(this);
    this.removeCard = this.removeCard.bind(this);
    this.clearCards = this.clearCards.bind(this);
    this.print = this.print.bind(this);
  }

  componentDidMount() {
    this.fetchIfNeeded(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchIfNeeded(nextProps);
  }

  componentDidUpdate(prevProps, prevState) {

  }

  fetchIfNeeded(props) {
    let {printQueue} = props;
    let selections = [];
    selections = printQueue.items.map(function (item, index) {
      return {
        id: item.id,
        text: item.label ? item.label : item.selection[0],
        items: item.selection
      };
    });
    this.setState({selections: selections});
  }

  moveCard(currentCardIndex, afterCardIndex) {
    let cards = _.clone(this.state.selections);
    let currentCard = cards[currentCardIndex];

    // remove the current Card
    cards.splice(currentCardIndex, 1);
    // put it after
    cards.splice(afterCardIndex, 0, currentCard);

    this.setState({selections: cards});
  }

  removeCard(id) {
    this.props.removeFromPrintQueue(id);
  }

  clearCards() {
    // this.setState({selections: []});
    this.props.clearPrintQueue();
    this.setState({returning: true});
    setTimeout(() => {
      this.setState({returning: false});
      browserHistory.goBack();
    }, 3000);
  }

  print() {
    let ids = [];
    let {intl} = this.props;
    let {selections} = this.state;
    selections.forEach(function (item) {
      ids.push(item.items);
    });
    window.open(printRoute(intl.locale, ids));
  }

  render() {
    let {selections, returning} = this.state;

    return (
      <div>
        <h1><FormattedMessage id="printQueue"/>&nbsp;
          <small style={{textTransform: 'lowercase'}}>(<a onClick={browserHistory.goBack}><FormattedMessage id="back"/></a>)</small>
        </h1>
        <div className="printQueueContainer">
          {selections.map((selection, i) => (
            <PrintQueueCard
              key={selection.id + '_' + i}
              index={i}
              id={selection.id}
              text={selection.text}
              moveCard={this.moveCard}
              removeCard={this.removeCard}
            />
          ))}
        </div>
        <Button className={selections.length === 0 ? 'disabled' : null} onClick={this.print} bsStyle="primary"><FormattedMessage id="print"/></Button>
        &nbsp;<Button style={{display: selections.length === 0 ? 'none' : null}} onClick={this.clearCards}><FormattedMessage id="clear"/></Button>
        &nbsp;{returning ? <span><FormattedMessage id="backToPrevious"/>&hellip;</span> : null}
      </div>
    );
  }
}

PrintQueueContainer.propTypes = {
  removeFromPrintQueue: PropTypes.func.isRequired,
  clearPrintQueue: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired
};


function mapStateToProps(state, ownProps) {
  let {printQueue, intl} = state;
  return {
    printQueue,
    intl
  };
}

function mapDispatchToProps(dispatch) {
  return {
    removeFromPrintQueue: bindActionCreators(removeFromPrintQueue, dispatch),
    clearPrintQueue: bindActionCreators(clearPrintQueue, dispatch)
  };
}

export default DragDropContext(HTML5Backend)(connect(mapStateToProps, mapDispatchToProps)(PrintQueueContainer));



/** WEBPACK FOOTER **
 ** ./src/modules/print/containers/PrintQueueContainer.js
 **/